import { withStillCorsCacheKey } from '@/lib/cover/withStillCorsCacheKey';

/**
 * The URL a carousel frame extractor loads (capture hook and frame picker).
 *
 * The extractor decodes with `crossOrigin="anonymous"`, but clip cards and the
 * editor play the same `storage.autoclipper.live` videos through plain
 * `<video>` elements, and that bucket caches non-CORS responses without
 * `Vary: Origin`. Reusing that cached copy blocks the CORS request ("No
 * 'Access-Control-Allow-Origin' header"). The `ac-still` cache key forces a
 * fresh CORS fetch (same rule as the cover still). Extractor input only —
 * never persist the tagged URL. Missing source → undefined (extractor idles).
 */
export function frameExtractorUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  return withStillCorsCacheKey(url);
}
